import FormattedMessage from 'I18n/components/FormattedMessage';
import { CLONE } from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { useFeaturePermission } from 'automation-ui-permissions/feature-permissions/hooks/featurePermissionHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useFlpAccess } from 'automation-ui-permissions/flp/hooks/useFlpAccess';
import WorkflowLimitsTrackableButton from 'automation-ui-management/components/upgrade-points/WorkflowLimitsTrackableButton';
import FlpRestrictedPropertiesMessage from 'automation-ui-management/components/flp/FlpRestrictedPropertiesMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const getDisabledTooltip = (disabledFeatureMessage, objectTypeAccessDisabledTitle, flpRejectionReasons, flpAccessError, hasFlpAccess) => {
  const presetTooltipTitle = disabledFeatureMessage || objectTypeAccessDisabledTitle;
  if (presetTooltipTitle) {
    return presetTooltipTitle;
  }
  if (flpAccessError) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.button.accessDisabled.flpLoadingError"
    });
  }
  if (!hasFlpAccess) {
    return /*#__PURE__*/_jsx(FlpRestrictedPropertiesMessage, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.button.accessDisabled.cloneFlp"
      }),
      flpRejectionReasons: flpRejectionReasons
    });
  }
  return null;
};
const OpenCloneFlowModalButton = ({
  'data-test-id': dataTestId,
  flowId,
  hasObjectTypeAccess,
  objectTypeAccessDisabledTitle,
  onClick,
  size,
  sourceApp,
  tooltipProps = {},
  upgradePoint,
  use
}) => {
  const {
    loading: loadingFlpAccess,
    data: flpAccessData,
    error: flpAccessError
  } = useFlpAccess(flowId);
  const {
    hasFeatureAccess,
    disabledFeatureMessage
  } = useFeaturePermission({
    sourceApp,
    feature: CLONE
  });
  const hasFlpAccess = !loadingFlpAccess && !flpAccessError && (flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.hasAccess(CLONE));
  const isAccessDisabled = !hasFeatureAccess || !hasObjectTypeAccess || !hasFlpAccess;
  const buttonContent = /*#__PURE__*/_jsx(WorkflowLimitsTrackableButton, {
    "data-test-id": dataTestId,
    onClick: onClick,
    trackableKey: Trackables.CLONE_WORKFLOW_CLICK,
    disabled: isAccessDisabled,
    immediate: true,
    upgradePoint: upgradePoint,
    size: size,
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.button.clone"
    })
  });
  if (isAccessDisabled) {
    const tooltipTitle = getDisabledTooltip(disabledFeatureMessage, objectTypeAccessDisabledTitle, (flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.flpRejectionReasons) || [], flpAccessError, hasFlpAccess);
    return /*#__PURE__*/_jsx(Tooltip, Object.assign({
      placement: "bottom right"
    }, tooltipProps, {
      title: tooltipTitle,
      children: buttonContent
    }));
  } else {
    return buttonContent;
  }
};
export default OpenCloneFlowModalButton;